export const getGenericModel = (response) => {
    return response.data
}
export const customerListGet = (response) => {
  if (response && response.data && response.data.success === true) {
    // Map the API response to our frontend model
    const customers = Array.isArray(response.data.data) ? response.data.data.map(customer => ({
      id: customer.id,
      slack: customer.slack,
      customer_code: customer.customer_code,
      name: customer.name,
      email: customer.email,
      phone: customer.phone,
      address: customer.address,
      dob: customer.dob,
      status: customer.status,
      status_data: customer.status_data ? {
        id: customer.status_data.id,
        value: customer.status_data.value,
        label: customer.status_data.label
      } : null,
      createdAt: customer.createdAt,
      updatedAt: customer.updatedAt,
      created_by: customer.created_by,
      updated_by: customer.updated_by,
      created_user: customer.created_user ? {
        id: customer.created_user.id,
        fullname: customer.created_user.fullname
      } : null,
      updated_user: customer.updated_user ? {
        id: customer.updated_user.id,
        fullname: customer.updated_user.fullname
      } : null
    })) : [];
    return {
      success: true,
      total: response.data.total || customers.length,
      data: customers
    };
  }
  return {
    success: false,
    message: response?.data?.message || 'Failed to fetch customer list',
    data: []
  };
};
